// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--0ec18";
export var logoWrapper = "styles-module--logoWrapper--73809";
export var ticker_wrap = "styles-module--ticker_wrap--1f024";